export enum DayPart {
  Morning = 'Morning',
  Midday = 'Midday',
  FullDay = 'FullDay',
}
